import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { style } from 'constant/constants';

const TextHighlightSpan = ({ messageStart, messageEnd, spanText }) => {
  return (
    <Grid style={{ fontFamily: style.fontFamily }}>
      {messageStart}
      <span style={{ backgroundColor: style.grayBackground }}> {spanText}</span>
      {messageEnd}
    </Grid>
  );
};

TextHighlightSpan.propTypes = {
  messageStart: PropTypes.string,
  messageEnd: PropTypes.string,
  spanText: PropTypes.string
};

export default TextHighlightSpan;
